import styled, { css } from "styled-components";
import { ReactComponent as LogoIcon } from "shared/asset/logo_hor.svg"

import { BASIC } from "shared/model/useThemeCookie"

const Style = {
    "LogoIcon": styled(LogoIcon)`
        fill: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
    `,
    "AdDiv": styled.div`
        flex-grow: 1;
        min-height: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.bg : theme.color?.gradation?.bg};
        `,
    "SrcDiv": styled.div`
        width: 101%;
        flex-grow: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;

        & > p {
            font-size: 32px;
            color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.bg : theme.color?.gradation?.font};
        }

        & > img {
            height: 101%;
            object-fit: fill;
        }

        & > video {
            height: 101%;
            object-fit: fill;

        }
    `,
    "TimerInfo": styled.div`
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;

        & > h1 {
            font-family: bold;
            font-size: 320px;
            line-height: 1;
            margin-bottom: 40px;

            ${({ $warning }) => $warning && css`
                color: red;
            `}
        }

        & > h2 {
            font-family: bold;
            font-size: 56px;
        }

        & > h3 {
            font-size: 40px;
        }
    `,
    "TimerTopDiv": styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 120px;

        & > h1 {
            font-family: bold;
            font-size: 52px;
        }

        & > div {
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 24px;

            & > h2 {
                font-family: bold;
                font-size: 40px;
                height: 40px;
                line-height: 0.8;
            }

            & > p {
                font-size: 32px;
                line-height: 1;
                padding: 12px 40px 16px 40px;
                border: 2px solid ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
                border-radius: 9999px;
            }
        }
    `,
    "TimerBottomDiv": styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 80px;
        margin: 35px 0 35px 0;

        & > div {
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 24px;

            & > h2 {
                font-family: bold;
                font-size: 40px;
                height: 40px;
                line-height: 0.8;
            }

            & > p {
                font-size: 32px;
                line-height: 1;
                padding: 12px 40px 16px 40px;
                border: 2px solid ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
                border-radius: 9999px;
            }
        }
    `,

    "PrizeDiv": styled.div`
        height: 100%;
        min-height: 0;
        width: 320px;
        min-width: 320px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 24px 24px 40px 24px;
    `,
    "PrizeListDiv": styled.div`
        flex-grow: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            width: 100%;
            text-align: center;
            font-family: bold;
            font-size: 40px;
            min-height: 40px;
            line-height: 1;
        }
    `,
    "PrizeList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
        overflow-y: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            display: none;
        }

        & > div {
            display: flex;
            justify-content: space-between;
            align-items: center;

            & > p {
                font-family: bold;
                font-size: 24px;
            }
        }
    `,
    "TotlePrizeDiv": styled.div`
        height: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        & > h2 {
            width: 100%;
            text-align: center;
            font-family: bold;
            font-size: 40px;
            min-height: 40px;
            line-height: 1;
        }

        & > p {
            font-size: 24px;
            line-height: 1.2;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical
        }
    `,
    "FallbackWarning": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 101%;
        background-color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.bg : theme.color?.gradation?.bg};
        color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
        gap: 20px;

        & > svg {
            width: 100px;
            height: 100px;
            fill: #ff4d4f;
        }

        & > p {
            font-size: 32px;
            color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
            text-align: center;
            opacity: 0.8;
            padding: 0 40px;
        }
    `,
    "LoadingContainer": styled.div`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        background-color: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.bg : theme.color?.gradation?.bg};
    `,
    "Loader": styled.div`
        width: 100px;
        padding: 8px;
        aspect-ratio: 1;
        border-radius: 50%;
        background: ${({ $themeType, theme }) => $themeType === BASIC ? theme.color?.basic?.font : theme.color?.gradation?.font};
        --_m: 
          conic-gradient(#0000 10%,#000),
          linear-gradient(#000 0 0) content-box;
        -webkit-mask: var(--_m);
                mask: var(--_m);
        -webkit-mask-composite: source-out;
                mask-composite: subtract;
        animation: l3 1s infinite linear;
        @keyframes l3 {to{transform: rotate(1turn)}}
    `,
}

export default Style
